module.exports = "pegasus_template/assets/theme5/header-image.jpg";